import styled from 'styled-components';

export const Container = styled.header`
  background: transparent;
`;

export const Content = styled.div`
  max-width: 1120px;
  margin: 0 auto;

  padding: 2rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    max-width: 30em;
  }

  div {
    display: flex;

    a + a {
      margin-left: 10px;
    }

    button {
      display: block;
      width: 100%;
      padding: 0.5rem 1rem;
      height: auto;
      background: var(--background);
      color: var(--text-title);
      border-radius: 0.5rem;
      border: 0;
      font-size: 1rem;
      font-weight: 500;

      transition: filter 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }

    button.white {
      background: transparent;
      color: white;
      border: 1px solid white;
    }
  }

  @media (max-width: 1407px) {
    .logo {
      max-width: 26em;
    }
  }

  @media (max-width: 1215px) {
    .logo {
      max-width: 22em;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    padding: 2rem 1rem 0rem 1rem;

    .logo {
      max-width: 23em;
    }

    a {
      margin-bottom: 1rem;
    }

    div {
      flex-direction: column;
      justify-content: center;

      a + a {
        margin-left: 0;
      }

      button {
        max-width: 190px;
        padding: 0.5rem;
      }
    }
  }
`;
